var $ = require("jquery");

jQuery(function () {

    // form phone consent
    let phoneConsent = $('#contact-form').find('input#phone-consent');
    phoneConsent.on('change', function(){
        $('#contact-form #phone-field').slideToggle();
        if(!this.checked){
            $('#contact-form #phone').val('');
        }
    });

    $('#contact-form').on('submit', function (ev) {
        // Prevent the form from actually submitting
        ev.preventDefault();

        // prevent ericjones bot
        let EJEmails = [
            'eric.jones.z.mail@gmail.com',
            'ericjonesmyemail@gmail.com'
        ];
        let formEmail = $('#contact-form').find('input#email').val();
        if (EJEmails.includes(formEmail)) {
            return false;
        } else {
            let loadingSpin = $(document).find('.loadingsvg').clone();
            $('#contact-response').html(loadingSpin).fadeIn();
            $('#contact-basic-submit-btn').attr('disabled', 'disabled');
            var data = $(this).serialize();

            // Send it to the server
            $.post('/wheelform/message/send',
                data,
                function (response) {
                    if (response.success) {
                        resp = response.message;

                        if($('#contact-form').find('#commercial-adv-consent').is(':checked')){
                            // dati da passare a mailchimp: nome, cognome, email e capire i 2 checkbox consent
                            // salvare/tentare di salvare solo se c'è il flag alle comunicazioni email
                            // prep data for mailchimp
                            var mailchimp_data = {
                                'CRAFT_CSRF_TOKEN': $('#contact-form').find('input[name="CRAFT_CSRF_TOKEN"]').val(),
                                'merge_fields': {
                                    'FNAME': $('#contact-form').find('input#firstname').val(),
                                    'LNAME': $('#contact-form').find('input#lastname').val(),
                                },
                                'email': $('#contact-form').find('input#email').val(),
                                'audienceId': $('#contact-form').find('input#audienceId').val(),
                                'language': 'it'
                            };

                            $.ajax({
                                headers: {
                                    'Accept': "application/json",
                                    'Content-Type': "application/json"
                                },
                                url: '/actions/mailchimp-subscribe/audience/subscribe',
                                type: 'post',
                                dataType: 'json',
                                data: JSON.stringify(mailchimp_data),
                                success: function (response) {
                                    if(response.success){
                                        respMC = 'Riceverai tra poco una mail con le istruzioni per finalizzare la registrazione.';
                                        $('#contact-mailchimp-response').empty().html('<p class="form-thanks">' + respMC + '</p>').fadeIn();
                                    } else {
                                        // console.log(response);
                                        respMC = 'Si è verificato un errore: ' + response.message;
                                        $('#contact-mailchimp-response').empty().html('<p class="form-errors">' + respMC + '</p>').fadeIn();
                                    }
                                },
                                error: function(response){
                                    respMC = resp + 'Si è verificato un errore con il server durante la registrazione.'
                                    $('#contact-mailchimp-response').empty().html('<p class="form-errors">' + respMC + '</p>').fadeIn();
                                }
        
                            });
                        }

                        $('#contact-response').empty().html('<p class="form-thanks">' + resp + '</p>').fadeIn();
                        // empty form
                        $('#contact-form')[0].reset();
                        if(phoneConsent.is(':checked')){
                            $('#contact-form #phone-field').slideToggle();
                        }
                        // analytics event form
                        if (typeof gtag === 'function') {
                            gtag('event', 'generate_lead', {
                                'event_category': 'form',
                                'event_action': 'send',
                                'event_label': 'contact'
                            });
                        }
                        if (typeof fbq === 'function') {
                            fbq('track', 'Lead', {'content_name': 'form contatto'});
                        }
                        $('#contact-basic-submit-btn').removeAttr('disabled');
                    } else {
                        // response.values will contain user submitted values
                        // response.errors will be an array containing any validation errors that occurred, indexed by field name
                        // e.g. response.error['email'] => ['Email is required', 'Email is invalid']
                        var errors = jQuery.map(response.errors, function(a){
                            return a[0];
                        });
                        $('#contact-response').empty().html('<p class="form-errors">Attenzione:<br> ' + errors.join("<br>") + '</p>').fadeIn();
                        $('#contact-basic-submit-btn').removeAttr('disabled');
                    }
                }
            );
        }
    });
});